import React, { useEffect, useRef } from 'react'
import MessageItem from './MessageItem'
import { Message, Attachment } from '../../types/messages'

interface MessagesListProps {
  messages: Message[]
  currentUserId: number | null
  onDownloadAttachment: (attachment: Attachment) => void
  loading: boolean
}

const MessagesList = ({ messages, currentUserId, onDownloadAttachment, loading }: MessagesListProps) => {
  const messagesContainerRef = useRef<HTMLDivElement>(null)

  const scrollToBottom = () => {
    if (messagesContainerRef.current != null) {
      messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight
    }
  }

  useEffect(() => {
    if (!loading && messages.length > 0) {
      scrollToBottom()
    }
  }, [messages, loading])

  useEffect(() => {
    scrollToBottom()
  }, [])

  return (
    <div
      ref={messagesContainerRef}
      className='tw-flex-grow tw-overflow-y-auto tw-px-4 tw-py-3 md:tw-px-6 md:tw-py-4'
    >
      {loading && messages.length === 0
        ? (
          <div className='tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-py-10 tw-text-gray-500'>
            <svg
              className='tw-animate-spin tw-h-8 tw-w-8 tw-text-green tw-mb-3'
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
            >
              <circle className='tw-opacity-25' cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='4' />
              <path className='tw-opacity-75' fill='currentColor' d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z' />
            </svg>
            <span className='tw-text-sm'>Ładowanie wiadomości...</span>
          </div>
          )
        : !loading && messages.length === 0
            ? (
              <div className='tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-py-10 tw-text-center tw-text-gray-500'>
                <i className='far fa-comments tw-text-4xl md:tw-text-5xl tw-text-gray-400 tw-mb-4' />
                <p className='tw-font-medium tw-text-base tw-text-gray-700'>Brak wiadomości</p>
                <p className='tw-text-sm tw-mt-1'>Rozpocznij konwersację, aby ją tutaj zobaczyć!</p>
              </div>
              )
            : (
              <div className='tw-space-y-4'>
                {messages.map(message => (
                  <MessageItem
                    key={message.id}
                    message={message}
                    currentUserId={currentUserId}
                    onDownloadAttachment={onDownloadAttachment}
                  />
                ))}
              </div>
              )}
    </div>
  )
}

export default MessagesList
